<template>
    <div>
        <DataTable v-if="resultmodel" 
            :loading="!resultmodel" 
            :value="resultmodel ? resultmodel : null" 
            responsiveLayout="scroll" 
            class="p-datatable-sm editable-cells-table" 
            :rowClass="selectedTransporter"
            v-model:expandedRows="expandedRows"
            @rowExpand="onRowExpand"
            @rowCollapse="onRowCollapse">
            <Column :expander="true" field="" header="">
                <template #header="">
                    <Button :icon="allExpanderIcon" class="p-button-rounded p-button-text" @click="onExpandAll"/>
                </template>
            </Column>
            <Column field="" header="No" style="width:10%">
                <template #body="slotProps">
                    {{slotProps.index + 1}}
                </template>
            </Column>
            <Column field="Document_No" :header="$t('document_no')" key="document_no" style="width:10%">  
            </Column>
            <Column field="Document_Date" :header="$t('document_date')" key="document_date" style="width:10%">
                <template #body="slotProps">
                    {{ $formatDate(slotProps.data.Document_Date) }}
                </template>  
            </Column>
            <Column field="Company_Code" :header="$t('company')" style="width:10%">  
            </Column>
            <Column field="Purchase_Organization" :header="$t('purchase_org')" style="width:10%">  
            </Column>
            <Column field="Purchase_Group" :header="$t('purchase_group')" style="width:10%">  
            </Column>
            <Column field="Transporter_Code" :header="$t('transporter')" style="width:10%">  
            </Column>
            <Column field="Load_Port" :header="$t('loading')" style="width:10%">  
            </Column>
            <Column field="Dest_Port" :header="$t('destination')" style="width:10%">  
            </Column>
            <Column field="Order_Type" :header="$t('order_type')" style="width:10%">  
            </Column>
            <!-- <Column field="Incoterm" :header="$t('incoterm')" style="width:10%">  
            </Column> -->
            <Column field="Shipment_Type" :header="$t('shipment_type')" style="width:10%">  
            </Column>
            <template #expansion="slotProps">
                <DataTable :value="slotProps.data.Details" style="position:sticky!important" responsiveLayout="scroll">
                    <Column field="Item_No" :header="$t('item_no')"> 
                    </Column>
                    <Column field="Material_Description" :header="$t('material')">
                    </Column>
                    <Column field="Qty" :header="$t('qty')">
                        <template #body="slotProps1">
                            {{this.$formatNumber(slotProps1.data.Qty)}}
                        </template>
                    </Column>
                    <!-- <Column field="Per" :header="$t('per')">
                    </Column> -->
                    <Column field="UOM" :header="$t('uom')">
                    </Column>
                </DataTable>
            </template>
        </DataTable>
    </div>
</template>
<script>
    export default{
        name: "_Result",
        emits:[ 'close' ],
        props:{
            resultmodel:{
                type:Object,
                default:null
            }
        },
        data(){
            return{
                expandedRows: [],
                allExpanderIcon:"pi pi-fw pi-chevron-down",
                expandAll: false,
            }
        },
        methods:{
            onRowExpand(event){
                this.expandedRows.push(event.data);
            },
            onRowCollapse(event){
                this.expandedRows.splice(this.expandedRows.indexOf(event.data), 1);
            },
        }
    }

</script>